import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 38,
  height: 28,
}

const serviceBedroom = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 37.416 37.416'
  >
    <g fill={color}>
      <path
        d='M36.791,229.947a6.586,6.586,0,0,0-6.537-5.855h-4.6a.731.731,0,1,0,0,1.462h4.6a5.124,5.124,0,0,1,5.063,4.385H13.592v-2.314a2.073,2.073,0,0,1,2.071-2.071H19.8a.731.731,0,1,0,0-1.462H15.662a3.529,3.529,0,0,0-2.833,1.424,3.652,3.652,0,0,0-5.813,4.422H5.408v-9.208A.731.731,0,0,0,4.677,220H.731a.731.731,0,0,0-.731.731v19.877a.731.731,0,0,0,.731.731H36.685a.731.731,0,0,0,.731-.731v-9.939A.73.73,0,0,0,36.791,229.947Zm-29.045-2.2a2.192,2.192,0,1,1,2.192,2.192A2.195,2.195,0,0,1,7.745,227.746Zm28.209,12.131H1.462v-5.554H12.436a.731.731,0,1,0,0-1.462H1.462v-11.4H3.946v9.208a.731.731,0,0,0,.731.731H35.954Z'
        transform='translate(0 -203.923)'
      />
      <path
        d='M301.213,276.214a.731.731,0,1,0,.517-.214A.736.736,0,0,0,301.213,276.214Z'
        transform='translate(-279.003 -255.83)'
      />
      <path
        d='M200.9,397.462a.731.731,0,1,0-.517-.214A.737.737,0,0,0,200.9,397.462Z'
        transform='translate(-185.542 -367.061)'
      />
      <path
        d='M162.744,82.93h1.477l-1.994,1.994a.731.731,0,0,0,.517,1.247h3.241a.731.731,0,1,0,0-1.462h-1.477l1.994-1.994a.731.731,0,0,0-.517-1.247h-3.241a.731.731,0,1,0,0,1.462Z'
        transform='translate(-150.173 -75.514)'
      />
      <path
        d='M131.064,189.783h.551l-1.068,1.068a.731.731,0,0,0,.517,1.248h2.315a.731.731,0,0,0,0-1.462h-.551l1.068-1.068a.731.731,0,0,0-.517-1.248h-2.315a.731.731,0,1,0,0,1.462Z'
        transform='translate(-120.809 -174.559)'
      />
      <path
        d='M274.989,17.977A8.989,8.989,0,1,0,266,8.989,9,9,0,0,0,274.989,17.977Zm0-16.516a7.527,7.527,0,1,1-7.527,7.527A7.536,7.536,0,0,1,274.989,1.462Z'
        transform='translate(-246.561)'
      />
      <path
        d='M453.048,114.554h.508a.731.731,0,0,0,0-1.462h-.508a.731.731,0,1,0,0,1.462Z'
        transform='translate(-419.262 -104.827)'
      />
      <path
        d='M300.7,113.639a.731.731,0,0,0-.731-.731h-.508a.731.731,0,0,0,0,1.462h.508A.731.731,0,0,0,300.7,113.639Z'
        transform='translate(-276.898 -104.657)'
      />
      <path
        d='M379.639,186.317a.731.731,0,0,0-.731.731v.508a.731.731,0,0,0,1.462,0v-.508A.731.731,0,0,0,379.639,186.317Z'
        transform='translate(-351.218 -172.701)'
      />
      <path
        d='M349.064,46.8H351.3a.731.731,0,0,0,.731-.73l.007-5.335a.731.731,0,0,0-.73-.732h0a.731.731,0,0,0-.731.73l-.006,4.6h-1.511a.731.731,0,0,0,0,1.462Z'
        transform='translate(-322.878 -37.077)'
      />
    </g>
  </svg>
)

export default serviceBedroom
